<template>
    <q-page class="col-md-6 offset-md-3 q-pt-xl row">
        <div class="col-md-8 offset-md-2">
            <q-banner v-if="memoLink" inline-actions rounded class="bg-negative text-white text-justify q-pa-sm">
                <template v-slot:avatar>
                    <q-icon name="fa-solid fa-hourglass-end" class="self-center full-height"/>
                </template>
                <p class="text-h7">
                    This link expired on
                    <strong><u>{{ date.formatDate(new Date(memoLink.expires_at), 'DD/MM/YYYY') }}</u></strong>
                </p>
                <p class="text-h7 q-ma-none">Please let the Memo Link creator know he needs to renew it to keep it
                    active</p>
            </q-banner>

            <q-banner v-else-if="!memoLink && !isDomainReserved" inline-actions rounded class="bg-warning text-dark text-justify q-pa-sm">
                <template v-slot:avatar>
                    <q-icon name="fa-solid fa-triangle-exclamation" class="self-center full-height"/>
                </template>
                <p class="text-h7 q-mb-none">
                    Memo Link
                    <strong v-if="route.params?.memoLink?.length"><u>{{ route.params?.memoLink[0] }}</u></strong>
                    <span v-if="subDomain"> with Domain <strong><u>{{ subDomain }}</u></strong></span>
                    not found
                </p>
            </q-banner>

            <q-banner v-else inline-actions rounded class="bg-warning text-dark text-justify q-pa-sm">
                <template v-slot:avatar>
                    <q-icon name="fa-solid fa-triangle-exclamation" class="self-center full-height"/>
                </template>
                <p class="text-h7 q-mb-none">
                    <span>This Domain is reserved</span>
                    <p>
                        Contact us on <a href="https://linkedin.com/company/memo-link" target="_blank">LinkedIn</a> to claim it
                    </p>
                </p>
            </q-banner>
        </div>
    </q-page>
</template>
<script setup>
import { useRoute, useRouter } from 'vue-router'
import { inject, onMounted, ref } from 'vue'
import { useMemoLinkService } from '../../../services/memoLinkService'
import { useSubDomainService } from '../../../services/subDomainService'
import { date, useQuasar } from 'quasar'

const route = useRoute()
const router = useRouter()
const quasar = useQuasar()
const memoLink = ref()
const mlService = useMemoLinkService()
const subDomainService = useSubDomainService();
const appDomain = inject('appDomain')
const appUrl = inject('appUrl')
const subDomain = ref('')
const isDomainReserved = ref(false);

subDomain.value = window.location.hostname.replace(appDomain, '').replace('.', '')

onMounted(async () => {
    if (route.params?.memoLink?.length) {
        quasar.loading.show()
        memoLink.value = await mlService
            .show(route.params?.memoLink[0], subDomain.value !== '' ? subDomain.value : null)
            .then(ml => {
                return ml
            })

        if (memoLink.value && memoLink.value.is_expired === false) {
            location.replace(memoLink.value.url)
        }

        if (!memoLink.value){
            await subDomainService
                .checkIsAvailable(subDomain.value)
                .then((response) => {
                    isDomainReserved.value = response.data.data.isReserved;
                });
        }

        quasar.loading.hide();
    } else {
        location.replace(appUrl);
    }
})
</script>

<style scoped>

</style>
